module.exports = __webpack_public_path__ + "642ee25e610a04aa3c4ebfcaa4d1a4b3.svg";